export default __webpack_public_path__ + "static/media/youtube.1c1aab01.svg";